// @flow
import React from 'react';
import ImageGallery from 'components/organisms/imageGallery';
import { ImageGalleryMobile } from 'components/organisms/imageGalleryMobile';
import { useViewport } from 'components/templates/viewportProvider';
import type { GalleryImageType } from 'types/common';

type Props = {
  data: {
    images: Array<GalleryImageType>,
    type?: string,
  },
};

const ImageGallerySection = (props: Props) => {
  const { height, isMobile } = useViewport();
  const { images } = props.data;
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div key={'image-gallery'} style={{ height }} id={'gallery'}>
      {isMobile ? (
        <ImageGalleryMobile images={images} />
      ) : (
        <ImageGallery images={images} />
      )}
    </div>
  );
};

export default ImageGallerySection;
